import React, { useState, useEffect, useRef } from "react";
import { Table, Col, Breadcrumb, Button, Space, Row } from "antd";
import { Link, useParams, useNavigate, useLocation, useSearchParams,} from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import plogo from "../../image/plogo.png";
import { getRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from 'moment';
import newLogo from "../../image/PROCEM3.svg";



const PurchaseOrderView = () => {
    const [orderData, setOrderData] = useState(null);
    console.log('orderData', orderData);
    
    const { id } = useParams();
    const buttonRef = useRef(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const pdfContainerRef = useRef(null);


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const action = queryParams.get("po_site_name");

    const units = ["", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE"];
    const tens = ["", "TEN", "TWENTY", "THIRTY", "FORTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"];
    const teens = ["TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN"];

    const zero = "ZERO";
    const arab = "ARAB";
    const crore = "CRORE";
    const lakh = "LAKH";
    const thousand = "THOUSAND";
    const hundred = "HUNDRED";
    const currency = "RUPEES";
    const paisa = "PAISA";
    const only = "ONLY";

    const convertNumberToWords= (amount) => {
        if (amount === 0) return `${zero} ${currency} ${only}`;

        function convert(num) {
            let parts = [];
            if (num >= 1e9) {
                parts.push(`${convert(Math.floor(num / 1e9))} ${arab}`);
                num %= 1e9;
            }
            if (num >= 1e7) {
                parts.push(`${convert(Math.floor(num / 1e7))} ${crore}`);
                num %= 1e7;
            }
            if (num >= 1e5) {
                parts.push(`${convert(Math.floor(num / 1e5))} ${lakh}`);
                num %= 1e5;
            }
            if (num >= 1000) {
                parts.push(`${convert(Math.floor(num / 1000))} ${thousand}`);
                num %= 1000;
            }
            if (num >= 100) {
                parts.push(`${convert(Math.floor(num / 100))} ${hundred}`);
                num %= 100;
            }
            if (num >= 20) {
                parts.push(`${tens[Math.floor(num / 10)]}`);
                if (num % 10 > 0) parts.push(units[num % 10]);
            } else if (num >= 10) {
                parts.push(`${teens[num - 10]}`);
            } else if (num > 0) {
                parts.push(`${units[num]}`);
            }
            return parts.join(" ");
        }

        let integerPart = Math.floor(amount);
        let wholeWordPart = convert(integerPart);
        let result = wholeWordPart ? `${wholeWordPart} ${currency}` : '';

        let decimalPart = Math.round((amount - integerPart) * 100);
        if (decimalPart > 0) {
            if (wholeWordPart) {
                result += " AND ";
            }
            result += `${convert(decimalPart)} ${paisa}`;
        }

        return `${result} ${only}`;
    }

    useEffect(() => {
        const getPoOrder = async () => {
            setLoading(true);
            try {
                const response = await getRequest(`po-order/${id}/po-copy-to-po-alloted-vendor/?po_site_name=${action}`);
                console.log(response);
                setOrderData(response.data.data);
                setLoading(false);
            } catch (error) {
                console.error("Error:", error.response.data.success);
                if (!error.response.data.success) {
                    setError(true);
                    setLoading(false);
                }
            }
        };
        getPoOrder();
    }, []);

    if (!orderData) {
        return <section
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >{!error && loading && (<span>Loading...</span>)}{error && !loading && (<span>Error</span>)}</section>;
    }
    const downloadAsPDF = () => {
        if (pdfContainerRef.current) {
            setIsDownloading(true);
            if (buttonRef.current) {
                buttonRef.current.classList.add("hide-in-pdf");
            }

            html2canvas(pdfContainerRef.current, {
                useCORS: true,
                scale: 1.5,
                logging: true,
            })
                .then((canvas) => {
                    const imgData = canvas.toDataURL("image/png");

                    const pdf = new jsPDF("l", "mm", "a4");
                    const imgProps = pdf.getImageProperties(imgData);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                    pdf.save(`Preview Purchase Order-${id}.pdf`);

                    if (buttonRef.current) {
                        buttonRef.current.classList.remove("hide-in-pdf");
                    }
                    setIsDownloading(false);
                })
                .catch((error) => {
                    console.error("Error generating PDF:", error);
                    if (buttonRef.current) {
                        buttonRef.current.classList.remove("hide-in-pdf");
                    }
                    setIsDownloading(false);
                });
        } else {
            console.error("PDF container reference is not defined.");
        }
    };
    const columns = [
        {
            title: "Sr.",
            dataIndex: "SrNo",
            width: "90px",
        },
        {
            title: "Item",
            dataIndex: "ItemDescription",
        },
        {
            title: "HSN",
            dataIndex: "HSN",
        },
        {
            title: "Qty.",
            dataIndex: "QTY",
        },
        {
            title: "UoM.",
            dataIndex: "UOM",
        },
        {
            title: "Delivery Date",
            dataIndex: "DeliveryDate",
        },
        {
            title: "Tax(%)",
            dataIndex: "Tax",
        },
        {
            title: 'Unit Rate',
            dataIndex: 'AmountWithoutGST',
        },
        {
            title: 'Basic Amount',
            dataIndex: 'AmountWithGST',
        }
    ];

    const data = orderData?.material_description.map((item, index) => ({
        SrNo: index + 1,
        ItemDescription: item.material_name,
        HSN: item.hsn_code,
        QTY: item.qty,
        UOM: item.uom,
        DeliveryDate: item.delivery_date,
        Tax: item.tax,
        AmountWithoutGST: "₹ " + (item.basic_unit_price)?.toFixed(2),
        AmountWithGST: "₹ " + (item.basic_amount)?.toFixed(2)
    }));

    return (
        <>
        <div className="invoice-container">
            <div className="ListingTopBar">
                <div className="pagenamewrap">
                    <div className="pagename">
                        <h3>Purchase Order View</h3>
                    </div>
                    <Space>
                        <ButtonField
                            className="BlueShadowBtn"
                            type="primary"
                            icon={<DownloadOutlined />}
                            label={isDownloading ? "Downloading..." : "Generate PDF"}
                            onClick={downloadAsPDF}
                            ref={buttonRef}
                        >
                            Download
                        </ButtonField>
                    </Space>
                </div>
            </div>

            <section className="grid-sec mt-5" ref={pdfContainerRef}>
            <div className="PR-body">
            <div className="order-header">
              {/* <div className="purchaselogo">
    {
      orderData.company_details[0].company_logo !== null ? <img src={orderData.company_details[0].company_logo} alt="" /> : ""
    }
    {orderData.company_details[0].name}
  </div> */}
              <div className="purchase-logo">
                <div className="company-info">
                  <div className="company-name">
                    <div className="company-logo">
                      {orderData.company_details[0].company_logo ? (
                        <img
                          src={orderData.company_details[0].company_logo}
                          // alt={`${orderData.company_details[0].name} Logo`}
                        />
                      ) : (
                        <img src={newLogo} alt="Default Company Logo" />
                      )}
                    </div>
                    <span style={{marginTop:"5px"}}>{orderData.company_details[0].name}</span>
                  </div>
                  <div className="separator"></div>
                </div>

                <div className="headdtl">
                  <h3>Buyer Details</h3>
                  <table className="table-style">
                    <tbody>
                      <tr>
                        <td className="heading">Name:</td>
                        <td className="table-style-head">
                          {orderData.company_details[0].name}
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">Mobile:</td>
                        <td className="table-style-head">
                          {orderData.company_details[0].phone_number}
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">Email:</td>
                        <td className="table-style-head">
                          {orderData.company_details[0].email}
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">Address:</td>
                        <td className="table-style-head">{`${orderData.company_details[0].registered_business_address_building}, ${orderData.company_details[0].registered_business_address_area}, ${orderData.company_details[0].registered_business_address_city}`}</td>
                      </tr>
                      <tr>
                        <td className="heading">GSTN:</td>
                        <td className="table-style-head">
                          {orderData.company_details[0].gst_number}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="headdtl">
                <h3>PO Details</h3>
                <table className="table-style">
                  <tbody>
                    <tr>
                      <td className="heading">PO Number:</td>
                      <td className="table-style-head">
                        {orderData.po_number}
                      </td>
                    </tr>
                    <tr>
                      <td className="heading">PO Date:</td>
                      <td className="table-style-head">
                        {orderData.po_created_date
                          ? moment(
                              orderData.po_created_date,
                              "DD-MM-YYYY"
                            ).format("DD/MM/YYYY")
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td className="heading">Payment Terms:</td>
                      <td className="table-style-head"> {orderData.payment_terms}</td>
                    </tr>
                    <tr>
                      {/* <td className="heading">INCO Terms:</td> */}
                      <td className="table-style-head"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* <Row gutter={[15]}>
              <Col xs={24} sm={24} md={8}>
                <div className="orderpdtl">
                  <h3>Seller</h3>
                  <p>
                    <strong>Name :</strong> {orderData.vendor_details[0].name}
                  </p>
                  <p>
                    <strong>Mobile :</strong>{" "}
                    {orderData.vendor_details[0].phone_number}
                  </p>
                  <p>
                    <strong>Email :</strong> {orderData.vendor_details[0].email}
                  </p>
                  <div className="adrs" style={{ marginTop: "10px" }}>
                    <strong>Address :</strong>{" "}
                    {`${orderData.vendor_details[0].registered_business_address_building}, ${orderData.vendor_details[0].registered_business_address_area}, ${orderData.vendor_details[0].registered_business_address_city}`}
                  </div>
                  <div className="gstn">
                    <strong>GSTN:</strong>{" "}
                    {orderData.vendor_details[0].gst_number}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <div className="orderpdtl">
                  <h3>BUYER</h3>
                  <p>
                    <strong>Name :</strong> {orderData.company_details[0].name}
                  </p>
                  <p>
                    <strong>Mobile: :</strong>{" "}
                    {orderData.company_details[0].phone_number}
                  </p>
                  <p>
                    <strong>Email :</strong>
                    {orderData.company_details[0].email}
                  </p>
                  <div className="adrs" style={{ marginTop: "10px" }}>
                    <strong>Address :</strong>{" "}
                    {`${orderData.company_details[0].registered_business_address_building}, ${orderData.company_details[0].registered_business_address_area}, ${orderData.company_details[0].registered_business_address_city}`}
                  </div>
                  <div className="gstn">
                    <strong>GSTN:</strong>{" "}
                    {orderData.company_details[0].gst_number}
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <div className="orderpdtl">
                  <h3>SITE LOCATION</h3>
                  <p>
                    <strong>Name :</strong>{" "}
                    {orderData.site_location[0].site_location}
                  </p>
                  <p></p>
                  <div className="adrs" style={{ marginTop: "10px" }}>
                    <strong>Address :</strong>{" "}
                    {orderData.site_location[0].billing_address_line_1},{" "}
                    {orderData.site_location[0].billing_address_line_2},{" "}
                    {orderData.site_location[0].billing_city}{" "}
                    {orderData.site_location[0].billing_state} -{" "}
                    {`${orderData.site_location[0].billing_pincode}`}
                  </div>
                  <div className="gstn">
                    <strong>GSTN:</strong>{" "}
                    {orderData.site_location[0].gst_number}
                  </div>
                </div>
              </Col>
            </Row> */}

            <Row gutter={[15]} style={{ marginTop: "10px" }}>
              <Col xs={24} sm={24} md={8}>
                <div className="details-column">
                  <h3 className="details-header">Vendor Details</h3>
                  <table className="table-style">
                    <tbody>
                      <tr>
                        <td className="heading">Name:</td>
                        <td>{orderData.vendor_details[0].name}</td>
                      </tr>
                      <tr>
                        <td className="heading">Mobile:</td>
                        <td>{orderData.vendor_details[0].phone_number}</td>
                      </tr>
                      <tr>
                        <td className="heading">Email:</td>
                        <td>{orderData.vendor_details[0].email}</td>
                      </tr>
                      <tr>
                        <td className="heading">Address:</td>
                        <td>
                          {`${orderData.vendor_details[0].registered_business_address_building}, ${orderData.vendor_details[0].registered_business_address_area}, ${orderData.vendor_details[0].registered_business_address_city}`}
                        </td>
                      </tr>
                      <tr className="last-row">
                        <td className="heading">GSTN:</td>
                        <td>{orderData.vendor_details[0].gst_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>

              <Col xs={24} sm={24} md={8}>
                <div className="details-column">
                  <h3 className="details-header">Billing Details</h3>
                  <table className="table-style">
                    <tbody>
                      <tr>
                        <td className="heading ">City:</td>
                        <td>
                          {
                            orderData.site_location[0].billing_details
                              .billing_city
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">Address:</td>
                        <td>
                          {`${orderData.site_location[0].billing_details.billing_address_line_1} ${orderData.site_location[0].billing_details.billing_address_line_2}, ${orderData.site_location[0].billing_details.billing_city}, ${orderData.site_location[0].billing_details.billing_state}, ${orderData.site_location[0].billing_details.billing_pincode}`}
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">GSTN:</td>
                        <td>{orderData.site_location[0].gst_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>

              <Col xs={24} sm={24} md={8}>
                <div className="details-column">
                  <h3 className="details-header">Shipping Details</h3>
                  <table className="table-style">
                    <tbody>
                      <tr>
                        <td className="heading ">City:</td>
                        <td>
                          {
                            orderData.site_location[0].shipping_details
                              .shipping_city
                          }
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">Address:</td>
                        <td>
                          {`${orderData.site_location[0].shipping_details.shipping_address_line_1} ${orderData.site_location[0].shipping_details.shipping_address_line_2}, ${orderData.site_location[0].shipping_details.shipping_city}, ${orderData.site_location[0].shipping_details.shipping_state}, ${orderData.site_location[0].shipping_details.shipping_pincode}`}
                        </td>
                      </tr>
                      <tr>
                        <td className="heading">GSTN:</td>
                        <td>{orderData.site_location[0].gst_number}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>

            <div className="hltxt">
              <strong>
                Reference: Vendor Final Offer : {orderData.po_number} |{" "}
                {orderData.material_description[0].delivery_date}
              </strong>
            </div>
            <Table
              className="poordertbl"
              columns={columns}
              dataSource={data}
              pagination={false}
            />
            <div className="invofooter po1">
              <table>
                <tr>
                  <th><b>Basic Sub Total:</b></th>
                  <td>
                    <b>
                    ₹{" "}
                    {orderData.total[0].basic_sub_total?.toLocaleString(
                      "en-IN",
                      { maximumFractionDigits: 0 }
                    )}
                    </b>
                  </td>
                </tr>
                <tr>
                  <th>CGST:</th>
                  <td>
                    ₹{" "}
                    {orderData.total[0].cgst?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </td>
                </tr>
                <tr>
                  <th>SGST:</th>
                  <td>
                    ₹{" "}
                    {orderData.total[0].sgst?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </td>
                </tr>
                <tr>
                  <th className="ttlbg"><b>Total:</b></th>
                  <td className="ttlbg">
                    <b>
                    ₹{" "}
                    {orderData.total[0].total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                    </b>
                  </td>
                </tr>
              </table>
            </div>
            <div className="hltxt">
              AMOUNT IN WORDS:{" "}
              <b>{convertNumberToWords(orderData.total[0].total.toFixed(0))}</b>
            </div>
            <Row gutter={[15]}>
              <Col xs={24} sm={24} md={12}>
                <div className="orderpdtl ftrsigntbl">
                  <h3>
                    <label>Other Terms:</label> The Seller has accepted order unconditionally.
                  </h3>
                  <p>
                    <strong>For, {orderData.company_details[0].name}</strong>
                  </p>
                  <p className="authsign">
                    <br />
                    <br />
                    Authorised Signatory
                  </p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <div className="orderpdtl ftrsigntbl rightalign">
                  <p>
                    <strong>For, {orderData.vendor_details[0].name}</strong>
                  </p>
                  <p className="authsign">
                    <br />
                    <br />
                    Authorised Signatory
                  </p>
                </div>
              </Col>
            </Row>

            <div className="details-container">
              <div className="details-wrapper">
                {/* Billing Key Persons Section */}
                <div className="key-person-section">
                  <h3 className="section-title">Billing Key Person</h3>
                  <table className="details-table">
                    <thead>
                      <tr className="table-header">
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderData.site_location[0].billing_details.billing_keypersons.map(
                        (person, index) => (
                          <tr key={index}>
                            <td>{person.name ? person.name : "NA"}</td>
                            <td>{person.email ? person.email : "NA"}</td>
                            <td>
                              {person.mobile_number
                                ? person.mobile_number
                                : "NA"}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="key-person-section">
                  <h3 className="section-title">Shipping Key Person</h3>
                  <table className="details-table">
                    <thead>
                      <tr className="table-header">
                        <th>Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderData.site_location[0].shipping_details.shipping_keypersons.map(
                        (person, index) => (
                          <tr key={index}>
                            <td>{person.name ? person.name : "NA"}</td>
                            <td>{person.email ? person.email : "NA"}</td>
                            <td>
                              {person.mobile_number
                                ? person.mobile_number
                                : "NA"}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

            </section>
        </div>
        </>
    );
};


export default PurchaseOrderView;
